<template>
  <div>
    <main class="container-fluid">
      <section class="row px-3">
        <div class="col-4 px-3 py-1 d-none d-md-flex"></div>

        <!-- Inicio do filtro-mobile -->
        <b-sidebar
          ref="sidebarFilter"
          id="sidebar-filter"
          no-header
          backdrop-variant="dark"
          backdrop
          shadow
          width="320px"
        >
          <div class="card-header d-flex justify-content-between">
            <a>Filtro</a>
            <a
              class="row justify-content-start pointer"
              @click="closeSidebarFilter"
              role="button"
            >
              <img
                src="../../../src/assets/icons/times-circle.svg"
                class="ico-15"
              />
            </a>
          </div>

          <div v-if="mobile" class="card card-body pt-2 pl-0">
            <Filters @alterFilter="alterFilter" :model="filter" />
          </div>
        </b-sidebar>
        <a
          v-if="mobile"
          id="btn-float-mobile"
          v-b-toggle.sidebar-filter
          class="btn"
          role="button"
        >
          <svg width="20" height="20" class="mb-1">
            <image
              xlink:href="../../../src/assets/icons/search.svg"
              width="20"
              height="20"
            />
          </svg>
        </a>
        <!-- Fim -->

        <div v-else class="col-4 col-md-4 mb-5">
          <Filters
            @updateTags="updateTags"
            @alterFilter="alterFilter"
            :model="filter"
          />
        </div>

        <div class="col-24 col-md-11 mb-4">
          <div class="flex-column align-self-start">
            <div class="row d-flex justify-content-between">
              <div class="col-sm-12 my-3">
                <div class="input-group">
                  <input
                    class="form-control filterInput"
                    v-model="txtSearch"
                    :placeholder="$ml.get('search')"
                    aria-label="Search"
                    style="border-right: none"
                  />
                  <div class="input-group-append">
                    <div
                      class="input-group-text"
                      style="background-color: #fff"
                    >
                      <svg width="20" height="20" class="mt-1">
                        <image
                          xlink:href="../../../src/assets/icons/search_s.svg"
                          width="18"
                          height="18"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div>
                  <p
                    class="time ml-1 m-0 mt-1"
                    v-text="
                      $ml
                        .with('results', ammountOfPages)
                        .with('totalResults', totalPages)
                        .get('showingResultsOfTotal')
                    "
                  >
                    Mostrando
                  </p>
                </div>
              </div>
              <div class="form-group mt-3">
                <button
                  v-if="permission"
                  @click="downloadCSVData()"
                  :disabled="loadingBtn"
                  class="btn ml-2 btn-export"
                >
                  <Spinner v-show="loadingBtn" class="px-5" />
                  <font
                    v-show="!loadingBtn"
                    class="mr-1"
                    v-text="$ml.get('exportReports')"
                    >Exportar relatórios</font
                  >
                  <img
                    v-show="!loadingBtn"
                    class="mb-1"
                    src="../../../src/assets/icons/download-white.svg"
                    width="15"
                    height="15"
                  />
                </button>
              </div>
            </div>
            <div v-if="$store.getters['getUserType'] == 'company'" class="row">
              <div class="col-24 mb-2">
                <a
                  block
                  @click="filterScope"
                  variant="info"
                  style="font-size: 0.85rem"
                  class="py-2 light justify-content-between align-items-center pointer"
                >
                  {{ $ml.get("filterScopeTitle") }}
                </a>
              </div>
              <div
                v-show="scopeTag"
                class="mt-1 mb-2 d-flex align-items-center"
                style="gap: 10px; flex-wrap: wrap"
              >
                <div
                  v-for="(tag, index) in scopeTag"
                  class="scope-tag"
                  :key="index"
                >
                  <span>{{ tag }}</span>
                  <span class="close" @click="removeTagScope(index)">x</span>
                </div>
              </div>
            </div>

            <!--Tags-->
            <!-- <div
              class="row"
              v-if="
                $store.getters['getUserType'] == 'company' && optionsTags.length
              "
            >
              <div no-body class="mb-2 w-100">
                <div
                  class="p-0 pt-1 mb-3"
                  header-tag="header"
                  role="tab"
                  style="background: #fff"
                >
                  <a
                    block
                    v-b-toggle.accordionTags
                    variant="info"
                    class="py-2 light justify-content-between align-items-center pointer"
                  >
                    {{ $ml.get("filterByTags") }}
                  </a>
                </div>
                <b-collapse
                  id="accordionTags"
                  accordion="my-accordion mb-3"
                  role="tabpanel"
                >
                  <div>
                    <form v-on:submit.prevent="">
                      <div class="row mb-3">
                        <b-form-checkbox-group
                          class="checkTags d-block"
                          v-model="selectedTags"
                          :options="optionsTags"
                          name="button"
                          buttons
                          @change="alterFilter"
                        >
                        </b-form-checkbox-group>
                      </div>
                    </form>
                  </div>
                </b-collapse>
              </div>
            </div> -->

            <div class="card">
              <div class="card-body">
                <div class="loading d-flex">
                  <div v-if="loading" class="c-loader"></div>
                  <h6
                    v-else
                    v-show="!listReports.length"
                    class="p-1"
                    v-text="$ml.get('noReportsFound')"
                  >
                    Nenhum relatório encontrado
                  </h6>
                </div>

                <div
                  class="d-column flex-row py-2"
                  v-for="(item, index) in listReports"
                  :key="index"
                >
                  <router-link
                    class="link-block"
                    :to="'/report/details?' + item.report_id"
                  >
                    <div
                      :class="
                        'h-profile h-profile-lg h-profile-report d-flex flex-column pb-3 align-items-center ' +
                        (index == listReports.length - 1 ? 'no' : '')
                      "
                    >
                      <div class="d-flex align-self-start h-profile">
                        <VueCustomTooltip :label="$ml.get('totalEvents')">
                          <div class="h-profile-points mt-1 mr-3">
                            <a alt="Total de eventos" class="link-block">{{
                              item.amount_of_events
                            }}</a>
                          </div>
                        </VueCustomTooltip>

                        <div class="h-profile-picture">
                          <div
                            v-if="$store.getters['getUserType'] == 'company'"
                            class="position-relative d-flex align-items-center mr-2"
                          >
                            <object
                              width="42"
                              height="42"
                              class="rounded-circle img-m"
                              :data="item.person_avatar"
                              type="image/png"
                            >
                              <img
                                width="42"
                                height="42"
                                class="rounded-circle img-m"
                                src="../../assets/images/default.png"
                                alt="Avatar"
                              />
                            </object>
                            <div v-show="item.hacker_verified" class="verify">
                              <img
                                src="../../../src/assets/icons/badge-check.png"
                                width="16"
                                height="16"
                              />
                            </div>
                          </div>

                          <object
                            v-else
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            :data="item.program_avatar"
                            type="image/png"
                          >
                            <img
                              width="42"
                              height="42"
                              class="rounded-circle img-m"
                              src="../../assets/images/default.png"
                              alt="Avatar"
                            />
                          </object>
                        </div>

                        <div class="d-flex w-100 align-items-start flex-column">
                          <div class="d-flex justify-content-between col">
                            <div class="d-flex align-items-center py-1">
                              <VueCustomTooltip
                                v-if="item.report_status == 'open'"
                                :label="$ml.get(item.report_status)"
                              >
                                <span
                                  class="badge badge-warning mr-2 align-self-center"
                                  >#{{ item.report_id }}</span
                                >
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                v-else
                                :label="$ml.get(item.report_status)"
                              >
                                <span
                                  class="badge badge-success mr-2 align-self-center"
                                  >#{{ item.report_id }}</span
                                >
                              </VueCustomTooltip>                             
                            </div>
                            <div class="report_campaign_active" v-if="item?.active_campaign">
                                <VueCustomTooltip
                                  :label="$ml.get('reportYithActiveCampaign')"
                                >
                                  <svg width="14" height="14" class="d-flex">
                                    <image
                                      xlink:href="../../../src/assets/icons/rocket-white.svg"
                                      width="14"
                                      height="14"
                                    />
                                  </svg>
                                </VueCustomTooltip>
                            </div>
                          </div>     
                          <div class="d-flex align-items-center pt-1">
                            <div class="pr-1">
                              <Impact
                                :impact="'impact-' + item.report_severity"
                              />
                            </div>
                            <h6 class="align-self-center mb-1">
                              <a
                                class="link-block"
                                v-text="item.report_title"
                              ></a>
                            </h6>
                          </div>                    
                          <p>
                            <font class="row">
                              <font
                                >Status:
                                <a v-text="$ml.get(item.report_status)"></a
                              ></font>
                            </font>

                            <font class="row my-1">
                              <font>
                                <font v-text="$ml.get('situation')"></font>:
                                <a
                                  class="text-capitalize"
                                  v-text="$ml.get(item.report_situation)"
                                ></a>
                              </font>
                            </font>

                            <font
                              class="row my-1"
                              v-if="
                                $store.getters['getUserType'] == 'company' &&
                                item.report_tags &&
                                item.report_tags.length
                              "
                            >
                              <font
                                class="d-flex"
                                style="gap: 5px; flex-wrap: wrap"
                              >
                                <font>Tags:</font>
                                <li
                                  v-for="(item, index) in item.report_tags"
                                  :key="index"
                                  class="badge b-form-tag mw-100 mr-2 tagsListReport"
                                >
                                  <span>{{
                                    $utils.capitalizeFirstLetter(item)
                                  }}</span>
                                </li>
                              </font>
                            </font>
                          </p>

                          <div
                            class="d-flex flex-row justify-content-between align-items-center w-100"
                          >
                            <p>
                              <font
                                v-if="
                                  $store.getters['getUserType'] == 'company'
                                "
                              >
                                <a
                                  v-text="
                                    item.deleted_author
                                      ? $ml.get('userRemoved')
                                      : item.hacker_username
                                  "
                                ></a
                                >&nbsp;
                                <font v-text="$ml.get('sentTheReport')">
                                  enviou o relatório</font
                                >
                              </font>
                              <font v-else v-text="$ml.get('reportSent')">
                                Relatório enviado
                              </font>
                              <a
                                class="pointer"
                                v-if="
                                  $store.getters['getUserType'] == 'company'
                                "
                              >
                                <strong v-text="item.company_name"></strong> </a
                              >&nbsp;
                              <font v-text="$ml.get('toTheProgram')"
                                >ao programa</font
                              >
                              <a class="pointer m-1 mb-2"
                                ><strong v-text="item.program_name"></strong>
                              </a>
                              <br />
                            </p>
                            <p class="time ml-1">
                              {{ $utils.formatDataLong(item.report_createdAt) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>

              <div v-show="totalPages > 10 && !loading" class="p-3">
                <b-pagination
                  v-model="pageActive"
                  :total-rows="totalPages"
                  :per-page="pageSize"
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')"
                  align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- Modal Scope -->
    <b-modal
      centered
      id="modal-scope"
      class="my-modal"
      data-bs-keyboard="false"
      hide-header
      size="lg"
      footer-bg-variant="light"
      @hide="closeModal"
    >
      <b-container fluid="lg">
        <div class="col modal-body">
          <h4 class="m-0">{{ $ml.get("selectScope") }}</h4>
        </div>
      </b-container>
      <div class="row">
        <div class="col-24 px-3 mb-3">
          <div class="form-group">
            <label class="text-muted" v-text="$ml.get('filterScope')">{{
              $ml.get("filterScope")
            }}</label>
            <multiselect
              v-model="scopeSelected"
              :options="
                formattedUrls.filter(
                  (tag) => !listScopeSelected.includes(tag.description)
                )
              "
              :placeholder="$ml.get('selectScope')"
              :searchable="true"
              label="description"
              :close-on-select="true"
              :show-labels="false"
              :allow-empty="false"
              :preselect-first="false"
              :multiple="false"
              @input="addTag(scopeSelected.description)"
            >
              <span slot="noResult" v-text="$ml.get('scopeNotFound')"
                >Escopo não encontrado.</span
              >
              <span slot="noOptions" v-text="$ml.get('noScopeAvailable')"
                >Nenhum escopo disponível.</span
              >
            </multiselect>
          </div>
        </div>

        <div v-if="listScopeSelected.length">
          <label class="text-muted"> {{ $ml.get("scopeSelected") }}</label>
          <div
            class="d-flex align-items-center"
            style="gap: 10px; flex-wrap: wrap-reverse"
          >
            <div
              v-for="(tag, index) in listScopeSelected"
              :key="index"
              class="scope-tag"
            >
              {{ tag }}
              <span class="close" @click="removeTagListSelected(index)">x</span>
            </div>
          </div>
        </div>
        <!-- <div v-if="listScopeSelected.length" class="px-3 mb-2">
          <label class="text-muted"> {{ $ml.get("scopeSelected") }}</label>
          <div v-if="(tag, index) in listScopeSelected" :key="index" class="scope-tag" style="padding-right: 4px">
            {{ tag.description }}
          </div>
        </div> -->
      </div>

      <template #modal-footer>
        <div class="w-100 float px-3">
          <b-button
            variant="primary"
            size="sm"
            class="float-right btn-outline-extra"
            v-text="$ml.get('cancel')"
            @click="$bvModal.hide('modal-scope')"
          >
          </b-button>

          <b-button
            v-if="listScopeSelected.length"
            class="float-right mr-3"
            variant="primary"
            size="sm"
            v-text="$ml.get('save')"
            @click="alterScope()"
          >
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import CompanyService from "../../services/company.service";
import ReportService from "../../services/report.service";
import Filters from "./filter";

export default {
  props: {
    filter: {
      type: String,
      required: true,
      default: "all",
    },
  },

  components: {
    Filters,
  },

  data() {
    return {
      scopeSelected: [],
      scopeSelectedOnly: "",
      scopeTag: "",
      scopeOptions: [],
      selected: [], // Must be an array reference!
      optionsTags: [],

      title: "Program",
      listReports: [],
      selectedTags: [],
      txtSearch: "",
      pageActive: 1,
      totalPages: 0,
      ammountOfPages: 0,
      pageSize: 10,
      filtersApp: [],
      loading: true,
      loadingBtn: false,
      mobile: window.innerWidth < 768,
      permission: true,
      listScopeSelected: [],
    };
  },
  created() {
    this.getScopeFilters();
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler);
    this.permission =
      ["owner", "administrator", "analyst"].includes(
        this.$store.getters["getUser"].role
      ) && this.$store.getters["getUserType"] == "company";

    if (this.$store.getters["getUserType"] === "company") this.changeTags();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },

  watch: {
    scopeTag() {
      this.alterFilter("", this.txtSearch);
      this.listScopeSelected = this.scopeTag;
    },
    pageActive: function () {
      this.alterFilter("", this.txtSearch);
    },
    txtSearch: function () {
      var self = this;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(function () {
        self.alterFilter("", self.txtSearch);
      }, 1000);
    },
  },
  computed: {
    formattedUrls() {
      return this.scopeOptions.map((item) => ({
        description:
          item.description.length > 80
            ? item.description.slice(0, 80) + "..."
            : item.description,
      }));
    },
  },

  methods: {
    addTag(scope) {
      this.listScopeSelected = [...this.listScopeSelected, scope];
      this.scopeSelected = [];
    },
    closeModal() {
      this.scopeSelected = [];
    },
    filterScope() {
      this.$bvModal.show("modal-scope");
    },
    alterScope() {
      this.scopeTag = [...this.listScopeSelected];
      this.$bvModal.hide("modal-scope");
      this.listScopeSelected = [];
    },
    removeTagScope(index) {
      const filtered = this.scopeTag.filter(
        (tag) => tag != this.scopeTag[index]
      );
      this.scopeTag = filtered;
    },
    removeTagListSelected(index) {
      const filtered = this.listScopeSelected.filter(
        (tag) => tag != this.listScopeSelected[index]
      );
      this.listScopeSelected = filtered;
    },
    async getScopeFilters(id) {
      try {
        const { data } = await ReportService.getScopeFilters(id);
        const cleanData = data
          ? data.filter(
              (it) => it.description.replace(" ", "").trim().length > 0
            )
          : [];
        this.scopeOptions = cleanData;
      } catch (error) {
        console.log(error);
      }
    },
    resizeHandler() {
      this.mobile = window.innerWidth < 768;
    },

    closeSidebarFilter() {
      this.$refs.sidebarFilter.hide();
    },

    changeTags() {
      this.optionsTags = [];
      CompanyService.getTags().then((response) => {
        this.optionsTags = response.data?.settings?.report_tags;
      });
    },

    updateTags(obj) {
      this.selectedTags = obj.tags;
      this.alterFilter();
    },
    alterFilter(filters) {
      if (filters) {
        this.filtersApp = filters;
      }

      this.loading = true;
      this.listReports = [];
      const req = this.filtersApp;

      let payload = "";
      if (this.scopeTag) {
        const arrayScope = Array.from(this.scopeTag);
        const scopes = arrayScope
          .map((tag) => `&scope=${encodeURIComponent(tag)}`)
          .join("");
        payload += `${scopes}`;
      }

      if (this.txtSearch) payload += `&search=${this.txtSearch}`;

      if (req.situations) payload += `&situation=${req.situations}`;

      if (req.program_types) payload += `&program_type=${req.program_types}`;

      if (req.period) payload += `&period=${req.period}`;

      if (this.filter === "triaged") payload += `&situation=${this.filter}`;

      if (req.status || ["pending", "retest"].includes(this.filter))
        payload += `&status=${req.status ? req.status : this.filter}`;

      if (req.program) {
        payload += `&programId=${req.program}`;
        this.getScopeFilters(req.program);
      }
      if (!req.program) {
        this.getScopeFilters();
      }

      if (req.severity) payload += `&severity=${req.severity}`;

      let tags = [];

      if (this.selectedTags.length) {
        tags = { tags: this.selectedTags };
      }

      ReportService.getListReports(
        this.pageActive,
        this.pageSize,
        payload,
        tags
      ).then(
        (response) => {
          this.loading = false;
          this.listReports = response.data.items;
          this.totalPages = response.data.total;

          if (this.listReports) {
            if (this.listReports.length == this.pageSize) {
              this.ammountOfPages = this.pageSize * this.pageActive;
            } else {
              this.ammountOfPages =
                this.pageSize * (this.pageActive - 1) +
                response.data.items.length;
            }
          }
        },
        () => {
          this.loading = false;
        }
      );
    },

    downloadCSVData() {
      this.loadingBtn = true;
      var self = this;

      ReportService.getReportsExport().then(
        (response) => {
          this.loadingBtn = false;

          if (response.data == "plan_not_allowed") {
            Swal.fire({
              icon: "info",
              html: `<h3 class="mb-2">${self.$ml.get(
                "notAvailableForThisPlan"
              )}<h3>
              <h5 class="mb-2">${self.$ml.get(
                "toAddThisFeatureCheck"
              )} <a href="/account?plans">${self.$ml.get("here")}</a>
              </h5>`,
              showConfirmButton: false,
              timer: 10000,
            });
          }

          var headers = {
            _id: "Id",
            status: this.$ml.get("status"),
            situation: this.$ml.get("situation"),
            severity: this.$ml.get("severity"),
            sent_at: this.$ml.get("sent_at"),
            author: this.$ml.get("author"),
            authorName: this.$ml.get("authorName"),
            program: this.$ml.get("program"),
            title: this.$ml.get("title"),
            createdAt: this.$ml.get("createdAt"),
            updatedAt: this.$ml.get("updatedAt"),
            closed_at: this.$ml.get("closed_at"),
            payment_requested: this.$ml.get("paymentRequested"),
            bounty_value: this.$ml.get("bounty_value"),
            company_bounty_status: this.$ml.get("company_bounty_status"),
            company_bounty_payment_date: this.$ml.get(
              "company_bounty_payment_date"
            ),
            hacker_bounty_status: this.$ml.get("hacker_bounty_status"),
            hacker_bounty_payment_date: this.$ml.get(
              "hacker_bounty_payment_date"
            ),
            weakness: this.$ml.get("weakness"),
            tags: this.$ml.get("tags"),
          };
          var itemsFormatted = [];
          // format the data
          response.data.forEach((item) => {
            switch (item.payment_requested) {
              case true:
                item.payment_requested = this.$ml.get("yes");
                break;
              default:
                item.payment_requested = this.$ml.get("no");
                break;
            }

            switch (item.severity) {
              case "low":
                item.severity = this.$ml.get("low");
                break;
              case "medium":
                item.severity = this.$ml.get("medium");
                break;
              case "high":
                item.severity = this.$ml.get("high");
                break;
              case "critical":
                item.severity = this.$ml.get("critical");
                break;
              default:
                item.severity = this.$ml.get("uninformed");
                break;
            }

            switch (item.situation) {
              case "spam":
                item.situation = this.$ml.get("spam");
                break;
              case "new":
                item.situation = this.$ml.get("new");
                break;
              case "duplicated":
                item.situation = this.$ml.get("duplicated");
                break;
              case "informative":
                item.situation = this.$ml.get("informative");
                break;
              case "not_applicable":
                item.situation = this.$ml.get("not_applicable");
                break;
              case "triaged":
                item.situation = this.$ml.get("triaged");
                break;
              case "approved":
                item.situation = this.$ml.get("approved");
                break;
              case "needs_information":
                item.situation = this.$ml.get("needs_information");
                break;
              case "pending_retest":
                item.situation = this.$ml.get("pending_retest");
                break;
              case "retest_done":
                item.situation = this.$ml.get("retest_done");
                break;
              default:
                item.situation = this.$ml.get("under_review");
                break;
            }

            switch (item.company_bounty_status[0]) {
              case "canceled":
                item.company_bounty_status = this.$ml.get("canceled");
                break;
              case "done":
                item.company_bounty_status = this.$ml.get("bounty_paid");
                break;
              case "pending":
                item.company_bounty_status = this.$ml.get("pending");
                break;
              default:
                item.company_bounty_status = this.$ml.get("unsolicited");
                break;
            }

            switch (item.hacker_bounty_status[0]) {
              case "canceled":
                item.hacker_bounty_status = this.$ml.get("canceled");
                break;
              case "done":
                item.hacker_bounty_status = this.$ml.get("bounty_paid");
                break;
              case "pending":
                item.hacker_bounty_status = this.$ml.get("pending");
                break;
              default:
                item.hacker_bounty_status = this.$ml.get("unsolicited");
                break;
            }

            itemsFormatted.push({
              _id: item._id,
              status:
                item.status == "open"
                  ? this.$ml.get("open")
                  : this.$ml.get("closed"),
              situation: item.situation,
              severity: item.severity,
              sent_at: this.$utils.formatDataShort(item.sent_at),
              author: item.personId,
              authorName: item.userName
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/;/g, ""),
              program: item.program
                ? item.program.replace(/(\r\n|\n|\r)/gm, "").replace(/;/g, "")
                : "",
              title: item.title
                ?.replace(/(\r\n|\n|\r)/gm, "")
                ?.replace(/;/g, "")
                ?.replace(/"/g, '""')
                ?.replace(/^"([^"]*)"$/g, "$1"),
              createdAt: this.$utils.formatDataShort(item.createdAt),
              updatedAt: this.$utils.formatDataShort(item.updatedAt),
              closed_at: item.closed_at
                ? this.$utils.formatDataShort(item.closed_at)
                : "--/--/----",
              payment_requested: item.payment_requested,
              bounty_value: item.bounty_value[0] ?? 0,
              company_bounty_status: item.company_bounty_status,
              company_bounty_payment_date: item.company_bounty_payment_date[0]
                ? this.$utils.formatDataShort(
                    item.company_bounty_payment_date[0]
                  )
                : "--/--/----",
              hacker_bounty_status: item.hacker_bounty_status,
              hacker_bounty_payment_date: item.hacker_bounty_payment_date[0]
                ? this.$utils.formatDataShort(
                    item.hacker_bounty_payment_date[0]
                  )
                : "--/--/----",
              weakness: item.weaknessType
                ? item.weaknessId + " " + item.weaknessType
                : this.$ml.get("uninformed"),
              tags: item.tags?.join(" - "),
            });
          });
          itemsFormatted.unshift(headers);

          // Convert Object to JSON
          var jsonObject = JSON.stringify(itemsFormatted);

          var array =
            typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;
          var csv = "";

          for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
              if (line != "") line += ";";
              line += array[i][index];
            }
            csv += line + "\r\n";
          }

          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download = "reports.csv";
          anchor.click();
        },
        () => {
          this.loadingBtn = false;
        }
      );
    },
  },
};
</script>
<style lang="scss">
.btn-export {
  padding-top: 6px !important;
  padding-bottom: 7px !important;
  align-self: flex-end !important;
  justify-content: flex-end !important;
}
.filterInput:focus {
  border-top: 1px solid #ced4da !important;
  border-bottom: 1px solid #ced4da !important;
  border-left: 1px solid #ced4da !important;
}
</style>
<style scoped>
.verify {
  right: -3px !important;
}
.time {
  color: #7d858e;
  font-size: 0.85rem;
  line-height: 1.3;
}
.scope-tag {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  /* max-width: 400px; */
  border: 1px solid #9c27b0;
  padding: 4px;
  border-radius: 5px;
  background: rgba(204, 204, 204, 0);
  text-align: center;
  color: #9c27b0;
  font-size: 0.8rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.close {
  /* position: absolute; */
  color: #730ba9;
  font-weight: 500;
  font-size: 1rem;
  top: 0px;
  right: 5px;
  cursor: pointer;
}
.report_campaign_active {
  background-color: #730ca9;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
